import { Component } from "@angular/core";
import { CurrentPhoneCallService } from "@modules/participant-shared/services/current-phone-call.service";
import { map, Observable } from "rxjs";

/**
 * Banner to show that the user is currently in a phone call.
 * The user can be considered to be in a phone call if they arrive at Stingray from Five9.
 */
@Component({
    selector: 'app-nav-phone-call-banner',
    templateUrl: './nav-phone-call-banner.component.html',
    styleUrls: ['./nav-phone-call-banner.component.scss']
})
export class NavPhoneCallBannerComponent {
    public readonly participantName: Observable<string | undefined>;
    public readonly employeeId: Observable<string | undefined>;

    constructor(currentPhoneCallService: CurrentPhoneCallService) {
        this.participantName = currentPhoneCallService.currentPhoneCallChanged()
            .pipe(map(phoneCall => phoneCall?.participantName));
        this.employeeId = currentPhoneCallService.currentPhoneCallChanged()
            .pipe(map(phoneCall => phoneCall?.employeeId));
    }
}